import browser from '@openclassrooms/utils/browser';
import $ from 'jquery';

export function scrollTop({ toSelector } = {}) {
  const $element = $(toSelector);
  $('html, body').animate(
    {
      scrollTop: $element.length ? $element.offset().top : 0,
    },
    'fast'
  );
}

export function scrollTo({ position } = {}) {
  $('html, body').animate(
    {
      scrollTop: position,
    },
    'fast'
  );
}

export function blockMainScroll() {
  const bodyElement = browser.document.body;

  bodyElement.style.height = '100%';
  bodyElement.style.overflow = 'hidden';

  return () => {
    bodyElement.style.height = 'auto';
    bodyElement.style.overflow = 'auto';
  };
}

export default {
  scrollTop,
  scrollTo,
  blockMainScroll,
};
